import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { FormattedMessage } from 'react-intl'
import Row from '@src/components/AdvertisingCampaign/Form/Row'
import Agreement from '../Agreement'
import Button from '@iui-kit/components/Button'
import BEM from '@iui-kit/utils/bem'
import { AGREEMENT } from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { Formik } from '@src/types/BriefSearch/formikProps'

const bem = new BEM(require('./BriefFooter.css'))

interface HOCProps {
  formik: Formik
}

const Footer: React.FC<HOCProps> = props => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched, isSubmitting }
  } = props

  return (
    <div className={bem.b('BriefFooter').show()}>
      <Row>
        <Agreement
          isValid={!errors[AGREEMENT] || !touched[AGREEMENT]}
          handleChange={handleChange}
          handleBlur={handleBlur}
          values={values}
        />
      </Row>
      <Button submit size="lg" theme="primary" disabled={isSubmitting}>
        <FormattedMessage id="Brief.search.submit" />
      </Button>
    </div>
  )
}

export default compose<React.FC>(connect)(Footer)
